import React, { useState } from "react";
import Header from "../components/Header";
import HomeVideo from "../components/HomeVideo";
import AboutSection from "../components/AboutSection";
import CoreValues from "../components/CoreValues";
import HomeProducts from "../components/HomeProducts";
import Footer from "../components/Footer";
import WhatsAppFloatingButton from "../components/WhatsAppFloatingButton";
import PageLoader from "../components/PageLoader";
import { Helmet } from "react-helmet";
const Home = () => {
  const [isOpen, setIsOpen] = useState(false);


  const homeProductsData = [
    // ✅ Renamed variable to avoid conflicts
    {
      name: "Blood Glucose",
      image: "/images/Dr Chek D (GOD)_270x270.webp",
      description: "Advanced monitoring for diabetes management.",
      learnMoreUrl: "/blood-glucose-meter",
      hasBrochure: true, // Enable Download Brochure button
      "brochure": {
      "pages": [
        "/images/Dr-Chek-D-Glucose-Meter-brochure-page-1.jpg",
        "/images/Dr-Chek-D-Glucose-Meter-brochure-page-2.jpg",
       
      ],
      "url": "/Dr.Chek-D-Glucose-Meter-brochure.pdf"
      },
    
    },
    {
      name: "Blood Pressure",
      image: "/images/Dr Chek BP_270x270.webp",
      description: "Accurate and reliable BP measurement devices.",
      learnMoreUrl: "/blood-pressure-meter",
      hasBrochure: true, // Enable Download Brochure button
      "brochure": {
      "pages": [
        "/images/Dr-Chek-BP-Blood-Pressure-Monitor-brochure-page-1.jpg",
        "/images/Dr-Chek-BP-Blood-Pressure-Monitor-brochure-page-2.jpg",
        
      ],
      "url": "/Dr-Chek-BP-Blood-Pressure-Monitor-brochure.pdf"
      },
    },
    {
      name: "Blood Hemoglobin",
      image: "/images/Dr Chek H_270x270.webp",
      description: "All-in-one health monitoring solution.",
      learnMoreUrl: "/Hemoglobin-meter",
      hasBrochure: true, // Enable Download Brochure button
      "brochure": {
      "pages": [
        "/images/Dr-Chek-H-Hemoglobin-Strips-Analyzer-brochure-1.jpg",
        "/images/Dr-Chek-H-Hemoglobin-Strips-Analyzer-brochure-2.jpg",
        
      ],
      "url": "/Dr.Chek-H-Hemoglobin-Strips-Analyzer-brochure.pdf"
      },
    },

    {
      name: "Blood Glucose +",
      image: "/images/Dr Chek D+ (GDH)  Meter Image_270x270.webp",
      description: "Advanced monitoring for diabetes management.",
      learnMoreUrl: "/blood-glucose-meter-plus",
      hasBrochure: true, // Enable Download Brochure button
      "brochure": {
      "pages": [
        "/images/Dr-Chek-D+-Glucose-Meter-brochure-page-1.jpg",
        "/images/Dr-Chek-D+-Glucose-Meter-brochure-page-2.jpg",
        
      ],
      "url": "/Dr.Chek-D+Glucose-Meter-brochure.pdf"
      },
    },
    {
      name: "Blood Pressure +",
      image: "/images/Dr Chek WBP_270x270.webp",
      description: "Accurate and reliable BP measurement devices.",
      learnMoreUrl: "/blood-pressure-meter-plus",
      hasBrochure: true, // Enable Download Brochure button
     "brochure": {
      "pages": [
        "/images/Dr-Chek-WBP-Blood-Pressure-Monitor-brochure-page-1.jpg",
        "/images/Dr-Chek-WBP-Blood-Pressure-Monitor-brochure-page-2.jpg",
    
      ],
      "url": "/Dr-Chek-WBP-Blood-Pressure-Monitor-brochure.pdf"
      },
    },
    {
      name: "Blood Hemoglobin +",
      image: "/images/Dr Chek H+_270x270.webp",
      description: "All-in-one health monitoring solution.",
      learnMoreUrl: "/Hemoglobin-meter-plus",
      hasBrochure: true, // Enable Download Brochure button
      "brochure": {
        "pages": [
          "/images/Dr-ChekH+-Hemoglobin-Cuvettes-Analyzer-brochure-page-1.jpg",
          "/images/Dr-ChekH+-Hemoglobin-Cuvettes-Analyzer-brochure-page-2.jpg",
          
        ],
        "url": "/D-Chek-H+-Hemoglobin-Cuvettes-Analyzer-brochure.pdf"
      },
    },
  ];

  const productData = {
    name: "Safe-Accu2",
    image:
      "",
    features: [
      "* Match EN ISO 15197:2015",
      "* No Coding",
      "* 0.6μL blood sample",
      "* Strip ejector",
      "* Indicator light warning",
    ],
    brochure: "/brochure.pdf",
  };

  const aboutData = {
    title: "About Dr.Chek",
    description: (
      <>
        Dr.Chek is a pioneering quality healthcare technology brand dedicated to
        revolutionizing chronic disease management. By harnessing the power of
        advanced biosensing technology, we develop, manufacture, and distribute
        a comprehensive portfolio of point-of-care diagnostic test products.{" "}
        <br></br>{" "}
      </>
    ),

    buttonText: "Learn More",
    buttonLink: "/about",
    imageUrl: "/images/Dr. Chek _Banners building.jpg",
    stats: [
      {
        value: "1",
        label:
          "India's first home health care brand with inhouse manufacturing capability.",
      },
      {
        value: "2",
        label:
          "State of the Art manufacturing facilities all set to create innovative products.",
      },
      {
        value: "9+",
        label:
          "Innovative Home Health Care & Point of Care Devices being launched in one year.",
      },
      {
        value: "18+",
        label:
          "Health Care focussed Channel Partners catering every corner of India.",
      },
      {
        value: "15000+",
        label:
          "Happy users experiencing a new level of confidence in their well-being.",
      },
    ],
  };
  const pages = [
    "/Dr. Protech D Glucose Meter_brochure_page-0001.jpg",
    "/Dr. Protech D Glucose Meter_brochure_page-0002.jpg",
  ];

  const brochureUrl = "/Dr.Chek-D-Glucose-Meter-brochure.pdf";


  return (
    <div>
      <Helmet>
  {/* Basic SEO */}
  <title>DrChek - Smart Healthcare & Diagnosis Solutions</title>
  <meta
    name="description"
    content="DrChek provides innovative healthcare and diagnostic solutions with advanced technology for accurate and efficient medical check-ups."
  />
  <meta
    name="keywords"
    content="Healthcare, Diagnosis, Medical Check-up, Smart Health, DrChek Blood glucose meter, Glucose meter, Blood sugar meter, Diabetes meter, Blood glucose monitoring, Blood sugar testing, Home glucose testing, glucometer, bgm"
  />
  <meta name="viewport" content="width=device-width, initial-scale=1" />

  {/* Canonical URL */}
  <link rel="canonical" href="https://www.drchek.com/" />

  {/* Open Graph for Facebook / LinkedIn */}
  <meta property="og:type" content="website" />
  <meta property="og:title" content="DrChek - Smart Healthcare & Diagnosis Solutions" />
  <meta
    property="og:description"
    content="Explore DrChek's home healthcare solutions with blood glucose, pressure, and hemoglobin meters."
  />
  <meta property="og:url" content="https://www.drchek.com/" />
  <meta property="og:image" content="https://www.drchek.com/images/drchek-og-image.jpg" /> {/* Replace with real image */}
  <meta property="og:site_name" content="DrChek" />

  {/* Twitter Card */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="DrChek - Smart Healthcare & Diagnosis Solutions" />
  <meta
    name="twitter:description"
    content="Discover DrChek's innovative home healthcare monitoring devices."
  />
  <meta name="twitter:image" content="https://www.drchek.com/images/drchek-og-image.jpg" />

  {/* Favicon (optional but recommended) */}
  <link rel="icon" href="/favicon.ico" type="image/x-icon" />
</Helmet>

      <main>
        <h1>Welcome to DrChek</h1>
      </main>
      <Header />
      <HomeVideo />
      <PageLoader />
     
      <AboutSection {...aboutData} />
      <HomeProducts products={homeProductsData} />{" "}
      {/* ✅ Correct variable name */}
      <CoreValues />
      {/* <Newsroom /> */}
      {/* <Doctors /> */}
      {/* <IndividualProduct product={productData} /> */}
     
      {/* <GalleryVideos/> */}
      <Footer />
      <WhatsAppFloatingButton />
    </div>
  );
};

export default Home;
